import axios from "axios";

export const localToken = () => {
  let token = sessionStorage.getItem("localToken");
  return token;
};

export const getCookieValue = (cookieName) => {
  const allCookies = decodeURIComponent(document.cookie).split("; ");
  for (let i = 0; i < allCookies.length; i++) {
    const cookie = allCookies[i];
    if (cookie.startsWith(cookieName + "="))
      return cookie.substring(cookieName.length + 1);
  }
  return "";
};
// const isProd = process.env.NODE_ENV === 'production';
const baseUrl = `https://ident.procreditbank.ge/api/api`;

let instance = axios.create({
  baseURL: baseUrl,
  headers: {
    Authorization: `Bearer ${localToken()}`,
    // "X-XSRF-TOKEN" : getCookieValue("XSRF-REQUEST-TOKEN").
  },
});

export const getInstance = (
  LocalToken,
  token,
  hashB /* hash generated in component*/
) => {
  if (token) sessionStorage.setItem("antiforgery", token);

  return (instance = axios.create({
    baseURL: baseUrl,
    headers: {
      Authorization: `Bearer ${LocalToken}`,
      "X-XSRF-TOKEN": token ? token : sessionStorage.getItem("antiforgery"),
    },
    // withCredentials: true,
  }));
};

export const getKeepzPostInstace = (LocalToken, token) => {
  if (token) sessionStorage.setItem("antiforgery", token);
  const temHeaders = LocalToken
    ? {
      Authorization: `Bearer ${LocalToken}`,
      "X-XSRF-TOKEN": token ? token : sessionStorage.getItem("antiforgery"),
      "X-Onboarding-Token":
        sessionStorage.getItem("onboardingToken") || localToken(),
    }
    : {
      "X-XSRF-TOKEN": token ? token : sessionStorage.getItem("antiforgery"),
      "X-Onboarding-Token": sessionStorage.getItem("onboardingToken"),
    };

  return (instance = axios.create({
    baseURL: baseUrl,
    headers: temHeaders,
  }));
};

export async function setAntiforgery() {
  return (instance = axios
    .create({
      baseURL: baseUrl,
      headers: {
        Authorization: `Bearer ${localToken()}`,
        // "X-XSRF-TOKEN" : getCookieValue("XSRF-REQUEST-TOKEN").
      },
    })
    .get("/Antiforgery"));
}

export async function apiCallWithAntiForgery(method, req, payload, hash) {
  const res = await setAntiforgery();
  return getInstance(localToken(), res.data, hash)[method](
    req,
    payload && payload
  );
}

export async function keepzApiCallWithAntiForgery(method, req, payload, hash) {
  const res = await setAntiforgery();
  return getKeepzPostInstace(localToken(), res.data, hash)[method](
    req,
    payload && payload
  );
}
